import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { useBreadCrumbsContext } from '../../hooks/contexts/breadCrumb.context';
import * as Style from './layout.styles';

/**
 * Main Layout content area (child route). Only on the tickets page does it grow to the end of
 * the viewport, so the empty states fill the free space via flex; on other routes it keeps the
 * Container's max-height (/naming relies on it to scroll the list internally).
 * The elements are the same in both cases (only the prop changes), so the child route doesn't
 * remount when isTicketPage is set after the first render.
 */
const LayoutContent: FC = () => {
  const { isTicketPage } = useBreadCrumbsContext();

  return (
    <Style.Content data-testid="layout-content" $fillViewport={isTicketPage}>
      <Style.ContentChild data-testid="layout-content-child" $fillViewport={isTicketPage}>
        <Outlet />
      </Style.ContentChild>
    </Style.Content>
  );
};

export default LayoutContent;
